<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption" v-if="options_loaded && passed_filter" :data-designer-component-id="component_id">
            <h3>Do you require enhanced security?</h3>
            <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                <i class="fa fa-circle-question"></i>
                <span v-html="floating_sidebar_message"></span>
            </div>
            <div class="stylesoption">
                <p class="align-center"><img :src="'https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/hallmark-sbd-banner.png'" alt="" style="border-radius: 15px;"></p>
                <div class="radiooption stylesoption">
                    <span v-for="option in filtered_option_list">
                        <label>
                            <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/>
                            {{ option.label }}
                        </label>
                    </span>
                </div>
            </div>
            <div v-if="extra_html !== null" v-html="extra_html"></div>
        </div>
    </div>


</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign
        ],
    }
</script>
